import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/ccpa-rights.md?raw';

export default function CCPARightsScreen() {
  return <LegalDoc markdown={markdown} title="California Privacy Rights" />;
}
